import {
	Component,
	Input
} from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';
import { IAudioTrack } from './IAudioTrack';
import { PLAYER_USER_PREFERENCE_KEY } from './shared/userPreference/PlayerUserPreferenceHandler';
import { PlayerUserPreferencesService } from './shared/userPreference/PlayerUserPreference.Service';

@Component({
	selector: 'vb-audio-menu',
	template: `
		@if (audioTracks?.length) {
			<ul role="menu" class="playerSettingsMenu">
				<li role="none" class="menuHeading"><span>{{ translations.audio }}</span></li>
				@for (audioTrack of audioTracks; track audioTrack.id) {
					<li role="none">
						<button type="button"
							role="menuitem"
							class="btn-link dropdown-item selectableItem"
							(click)="onTrackChange(audioTrack)">
							@if((vgApi.activeAudioTrack$ | async)?.id === audioTrack.id) {
								<span class="glyphicons ok_2"></span>
							}
							{{ audioTrack.displayLabel }}
							@if (audioTrack.default) {
								<span> ({{ translations.original }}) </span>
							}
						</button>
					</li>
				}
			</ul>
		}
	`,
	standalone: false,
	styleUrls: ['./VbPlayerSettingsMenu.Component.ng.less', './MenuButton.ng.less']
})
export class VbAudioMenuComponent {
	@Input() public selectedCssClass: string;
	@Input() public translations: any;
	@Input() public audioTracks: IAudioTrack[];

	constructor(
		public vgApi: VideogularComponent,
		private readonly PlayerUserPreferencesService: PlayerUserPreferencesService,
	) {}


	public onTrackChange(track: IAudioTrack): void {
		this.vgApi.setActiveAudioTrack(track);
		this.PlayerUserPreferencesService.setPreference<IAudioTrack>(PLAYER_USER_PREFERENCE_KEY.AUDIO_TRACK, track);
	}

}
